<script setup lang="ts">
const emit = defineEmits<{
  (e: "open"): void;
}>();

const { coupleName, guestText, openInvitation } = useOpeningCard();

async function onOpen() {
  const canOpen = await openInvitation();

  if (canOpen) {
    emit("open");
  }
}
</script>

<template>
  <div
    class="fixed inset-0 z-60 flex items-center justify-center bg-neutral-950/25 backdrop-blur-[2px] h-safe-screen m-auto overflow-hidden"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cover-dialog-title"
    aria-label="Kartu Undangan Pernikahan"
  >
    <div class="flex-1 flex p-4 xs:p-6 md:p-8 lg:p-10 size-full overflow-y-auto">
      <div
        class="rounded-3xl bg-white shadow-xl flex flex-col w-full h-max overflow-hidden m-auto max-w-md"
      >
        <!-- Opening Card Image -->
        <NuxtImg
          src="/opening-card.webp"
          alt="Cover Kartu Undangan"
          class="w-full h-70 md:h-75 object-cover"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          :preload="{
            fetchPriority: 'high',
          }"
        />

        <div class="flex flex-col text-center flex-1 w-full relative">
          <!-- Opening Card Decoration -->
          <NuxtImg
            src="/opening-card-decoration.webp"
            alt="Dekorasi Kartu Undangan"
            class="pointer-events-none absolute inset-0 w-full h-full object-cover"
            loading="eager"
            decoding="async"
            fetchpriority="high"
            :preload="{
              fetchPriority: 'high',
            }"
          />

          <div class="p-6 flex flex-col gap-4 z-10">
            <header
              class="flex flex-col gap-2"
            >
              <p
                class="uppercase text-sm xs:text-base"
              >
                PERNIKAHAN
              </p>

              <h1
                class="text-primary-800 font-cursive font-medium text-3xl my-2 xs:text-4xl lg:text-5xl"
              >
                {{ coupleName }}
              </h1>
            </header>

            <div class="flex flex-col gap-2">
              <p>
                Dear,
              </p>

              <h2
                class="text-base text-primary-800 font-medium xs:text-lg sm:text-xl md:text-2xl"
              >
                {{ guestText }}
              </h2>
            </div>

            <footer
              class="flex flex-col gap-4 max-w-3xs xs:max-w-2xs sm:max-w-xs mx-auto"
            >
              <p
                class="text-xs xs:text-sm"
              >
                Kami mengundang Anda untuk bergabung dengan kami dalam momen bahagia ini
              </p>

              <UButton
                label="Buka Undangan"
                variant="soft"
                class="w-fit mx-auto mt-3 rounded-full"
                block
                @click="onOpen"
              />
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
